import React from 'react';

import { Container } from './styles';

export default function Dashboard() {
  return (
    <Container>
      <div className="row abastecimento" />
    </Container>
  );
}
